export const contractSaveParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  action = 'save',
}) => {
  const options = new URLSearchParams()

  const ensureCorrectCommissionFormat = value => {
    return value.replace(',', '.')
  }

  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('action', action)
  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('product_type', characteristicsData.productType || '')
  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')
  options.append('provider_external_id', contractData.providerExternalId || '')
  //to-do-v2: check if it is necessary
  if (contractData.annualPremium?.length > 0) {
    options.append('annual_premium', ensureCorrectCommissionFormat(contractData.annualPremium))
  }
  //to-do-v2: check if it is necessary
  if (contractData.annualCommission?.length > 0) {
    options.append('annual_commission', ensureCorrectCommissionFormat(contractData.annualCommission))
  }

  return options
}
